import { RouterType } from '@online-webinar/router';
import { DeleteWebinarPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/delete'].update({
        staticData: { title: { webinar: 'Title.DeleteWebinar' } },
        component: authGuard(DeleteWebinarPage, { canBroadcast: true })
    });
};
